import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
// The parameter used for specifying the sort orders(i.e field: string)
// should be one of the property of the array as string,
// passing function as string won't work.
// ex: 'fieldName = x.value.valueOf()' won't work with orderBy:fieldName:reverse
@Pipe({
    name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
    public transform<T>(array: T[], field: string, reverse = false): T[] | undefined {
        if (!Array.isArray(array)) {
            return;
        }
        const sortedArray = _.orderBy(array, field, 'asc');
        // Cannot use "reverse" value directly into orderBy function because
        // 'desc' acts differently than 'asc' when using _.orderBy
        // https://github.com/lodash/lodash/issues/3285
        const reversedArray = reverse ? _.reverse(sortedArray) : sortedArray;

        // empty and re-fill array parameter to make sure that we use the same reference. If we don't do that,
        // a ngFor would use the array we return instead of the original array. This would mean that changes to the
        // original array would not be reflected in the rendered content because it is not using the original array.
        array.length = 0;
        reversedArray.forEach((el) => array.push(el));
        return array;
    }
}
